import newRelic from '@Shared/lib/new-relic'

const gradImagesIdentityString = 'GradImages'
const universityPhotoIdentityString = 'UniversityComposites'
const letterJacketIdentityString = 'LetterJacket'
const picturedayIdentityString = 'Pictureday'
export default {
  computed: {
    siteIdentity () {
      try {
        const siteIdentity = window.pageData.siteIdentity

        if (siteIdentity === undefined || siteIdentity === null) {
          newRelic.noticeError(
            `Unable to retrieve site identity for url ${window.location.href}`
          )
          return null
        }

        if (
          [
            gradImagesIdentityString,
            universityPhotoIdentityString,
            letterJacketIdentityString,
            picturedayIdentityString
          ].indexOf(siteIdentity) > -1
        ) {
          return siteIdentity
        } else {
          newRelic.noticeError(
            `Site identity '${siteIdentity}' was not an expected value`
          )
          return null
        }
      } catch (e) {
        newRelic.noticeError(
          `Unable to retrieve site identity for url ${window.location.href}`
        )
        return null
      }
    },
    siteIdentityStyleModifier () {
      return this.siteIdentity.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() // converts camel-cased name to slug (dash separated). ex: CamelCase -> camel-case
    },
    isGradImages () {
      const siteIdentity = this.siteIdentity

      if (siteIdentity !== null) {
        return siteIdentity === gradImagesIdentityString
      } else {
        return false
      }
    },
    isPictureDay () {
      const siteIdentity = this.siteIdentity

      if (siteIdentity !== null) {
        return siteIdentity === picturedayIdentityString
      } else {
        return false
      }
    },
    isUniversityPhoto () {
      const siteIdentity = this.siteIdentity

      if (siteIdentity !== null) {
        return siteIdentity === universityPhotoIdentityString
      } else {
        return false
      }
    },
    isLetterJacket () {
      const siteIdentity = this.siteIdentity

      if (siteIdentity !== null) {
        return siteIdentity === letterJacketIdentityString
      } else {
        return false
      }
    }
  },
  methods: {
    siteIdentityClass (cssClass) {
      return [
        cssClass,
        `${cssClass}--${this.siteIdentityStyleModifier}`
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/mixins/site-identity.js